import React, { useRef } from "react";
import { AiFillStar, AiOutlineMenu } from "react-icons/ai";
import Checkbox from "@mui/material/Checkbox";
import CustomTooltip from "../../Tooltip/CustomTooltip";
export default function QuestionsHeader({
  title,
  description,
  required,
  onChangeTitle,
  onChangeDescription,
  onChangeRequired,
  onFocus,
  onEdit = false,
}) {
  const [checked, setChecked] = React.useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  return (
    <>
      <div className="w-full flex justify-center items-center">
        <input
          onFocus={onFocus}
          type="text"
          name="floating_email"
          id="floating_email"
          className="block py-2.5 px-0  mr-4 w-full text-2xl  text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none  focus:outline-none focus:ring-0 focus:border-blue-600 peer"
          placeholder=" "
          required
          value={title}
          onChange={onChangeTitle}
        />

        <CustomTooltip title={"Soruya açıklama ekleminizi sağlar."}>
          <Checkbox
            checked={checked}
            onChange={handleChange}
            icon={<AiOutlineMenu size={25} />}
            checkedIcon={
              <AiOutlineMenu size={25} className="text-blue-400 mt-2" />
            }
          />
        </CustomTooltip>
        {!onEdit && (
          <CustomTooltip
            title={
              "Soruya zorunluluk eklemenizi sağlar.Zorunlu sorular doldurulmadan geçilemez"
            }
          >
            <Checkbox
              checked={required}
              onChange={onChangeRequired}
              icon={<AiFillStar size={25} />}
              checkedIcon={
                <AiFillStar size={25} className="text-red-400 mt-2" />
              }
            />
          </CustomTooltip>
        )}
      </div>
      {checked && (
        <input
          onFocus={onFocus}
          type="text"
          name="floating_email"
          id="floating_email"
          className="block py-2.5 px-0 w-full  text-sm  text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none  focus:outline-none focus:ring-0 focus:border-blue-600 peer"
          placeholder=" "
          required
          value={description}
          onChange={onChangeDescription}
        />
      )}
    </>
  );
}
